module.exports = __webpack_public_path__ + "img/phone.2794c9e9.png";